import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
// import { useAuth } from "../../app/useAuth";
import MainLayout from "../../components/layouts/main";

export default function N1Records() {
    // const auth = useAuth();
    const navigate = useNavigate();
    const [textSearch, setTextSearch] = useState("");
    const [submitSearch, setSubmitSearch] = useState(false);
    const [advancedSearch, setAdvancedSearch] = useState("all");
    const [advancedSearchText, setAdvancedSearchText] = useState("");

    const handleSubmitSearch = useCallback(() => {
        const checkAdvancedSearchObject = JSON.stringify(advancedSearchText) === JSON.stringify({});
        if (checkAdvancedSearchObject) {
            navigate(`/search/n1/${textSearch ? textSearch : advancedSearchText}`);
        } else {
            const urlParams = new URLSearchParams(advancedSearchText).toString();
            navigate(`/search/n1/advanced?${urlParams}`);
        }
        setSubmitSearch(false);
    }, [textSearch, navigate, advancedSearch, advancedSearchText]);

    useEffect(() => {
        if (submitSearch) {
            handleSubmitSearch();
        }
    }, [submitSearch, handleSubmitSearch]);

    const arrRules = [
        {
            title: "Sequence Name",
            value: "sequence_name",
        },
        {
            title: "Sequence Description",
            value: "sequence_description",
        },
        {
            title: "GO ID",
            value: "inter_pro_go_id",
        },
        {
            title: "GO Term",
            value: "inter_pro_go_term",
        },
        {
            title: "Blast Top Hit Accession",
            value: "blast_top_hit_accession",
        },
        {
            title: "Mapping Gene Name",
            value: "mapping_gene_name",
        },
        {
            title: "Enzyme Code",
            value: "enzyme_code",
        },
        {
            title: "Enzyme Name",
            value: "enzyme_name",
        },
    ];

    return (
        <MainLayout
            pathname="/search/n1"
            arrRules={arrRules}
            header="Rice EST"
            exampleText={
                <div>
                    Examples - Sequence Name: <span className="text-primary">gi|29615904|gb|CB620916.1|</span>, Blast Top Hit Accession:{" "}
                    <span className="text-primary">CAH66705</span>,<span className="text-primary">EEC78163</span>
                </div>
            }
            textSearch={textSearch}
            setTextSearch={setTextSearch}
            setSubmitSearch={setSubmitSearch}
            setAdvancedSearch={setAdvancedSearch}
            advancedSearchText={advancedSearchText}
            setAdvancedSearchText={setAdvancedSearchText}
        />
    );
}
